import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import { isPhotoEvent } from "src/modules/activity-log/supported-events";

import Modal from "src/components/Modal";
import Dialog from "src/components/Dialog";
import CloseButton from "src/atoms/CloseButton";

import CapturedMediaMenu from "./CapturedMediaMenu";
import CapturedSnapshot from "./CapturedSnapshot";
import CapturedVideo from "./CapturedVideo";

function CapturedMedia({
  type,
  onClose,
  src,
  videoThumbnailSrc,
  ratio,
  onDelete,
  onDownload,
  autoplay
}) {
  const { t } = useTranslation();
  const isImageMedia = isPhotoEvent(type);
  const isVideoMedia = !isImageMedia;

  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <>
      <Dialog
        isOpen={isOpenDeleteDialog || isDeleting}
        isProcessing={isDeleting}
        processingText={t("deleting")}
        heading={
          isImageMedia
            ? t("activityLog.deletePhotoDialog.heading")
            : t("activityLog.deleteVideoDialog.heading")
        }
        text={
          isImageMedia
            ? t("activityLog.deletePhotoDialog.text")
            : t("activityLog.deleteVideoDialog.text")
        }
        buttons={[
          {
            text: t("buttons.cancel"),
            onClick: () => setIsOpenDeleteDialog(false)
          },
          {
            text: t("buttons.ok"),
            onClick: () => {
              setIsOpenDeleteDialog(false);
              setIsDeleting(true);
              onDelete();
            }
          }
        ]}
      />
      <Box position="absolute" top="10px" left="52px" zIndex={10}>
        <CapturedMediaMenu onDelete={onDelete} onDownload={onDownload} />
      </Box>
      {isImageMedia && <CapturedSnapshot src={src} onClose={onClose} />}
      {isVideoMedia && (
        <CapturedVideo
          ratio={ratio}
          src={src}
          videoThumbnailSrc={videoThumbnailSrc}
          autoplay={autoplay}
          onClose={onClose}
        />
      )}
    </>
  );
}

export default function CapturedMediaPopover({ isOpen, onClose, ...rest }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      bodyProps={{ bg: "transparent" }}
      modalProps={{ closeOnOverlayClick: false }}
    >
      <Box
        maxWidth="632px"
        maxHeight="90vh"
        pos="relative"
        borderRadius="12px"
        overflow="hidden"
      >
        <Box
          position="absolute"
          top="0"
          right="0"
          width="120px"
          height="120px"
          zIndex="10"
          backgroundImage="linear-gradient(to top right,rgba(0, 0, 0, 0),85%,rgba(0, 0, 0, 0.6))"
        />
        <CloseButton onClick={onClose} fill="white" absolute />
        {isOpen && <CapturedMedia onClose={onClose} {...rest} />}
      </Box>
    </Modal>
  );
}
